import { Transform } from 'class-transformer';

export function Status(
  statusList: readonly { value: string; viewValue: string; class: string }[],
  statusField = 'status'
) {
  return Transform(({ obj }) => {
    const defaultValue = { value: obj[statusField], viewValue: obj[statusField] };
    if (!obj[statusField]) return defaultValue;

    const statusDetail = statusList.find(status => status.value === obj[statusField]);
    if (!statusDetail) return defaultValue;

    return {
      value: obj[statusField],
      viewValue: statusDetail.viewValue,
      class: statusDetail.class,
    };
  });
}
